var _rect, _rect2, _rect3, _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRemoteHappening(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 575,
    height: 324,
    viewBox: "0 0 575 324",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 575,
    height: 324,
    rx: 10,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 575,
    height: 324,
    rx: 10,
    fill: "#F9F9F9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 575,
    height: 324,
    rx: 10,
    fill: "url(#paint0_radial_2397_18030)",
    fillOpacity: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M261.163 165.065H311.748C314.54 165.065 316.388 163.277 316.388 160.524V140.958C316.388 138.205 314.54 136.417 311.748 136.417H311.045V136.216C311.045 133.062 309.317 131.395 306.183 131.395H270.263C267.25 131.395 265.402 133.062 265.402 136.216V159.902H261.163C259.757 159.902 258.592 161.067 258.592 162.493C258.592 163.899 259.757 165.065 261.163 165.065ZM297.866 140.958V159.902H269.4V137.281C269.4 135.995 270.022 135.393 271.288 135.393H305.159C306.083 135.393 306.665 135.734 306.906 136.417H302.587C299.755 136.417 297.866 138.205 297.866 140.958ZM301.06 141.44C301.06 140.295 301.784 139.612 302.989 139.612H303.27V140.415C303.27 141.118 303.732 141.58 304.415 141.58H309.859C310.563 141.58 311.005 141.118 311.005 140.415V139.612H311.266C312.471 139.612 313.194 140.315 313.194 141.46V160.042C313.194 161.187 312.471 161.87 311.266 161.87H302.989C301.784 161.87 301.06 161.187 301.06 160.042V141.44ZM304.074 160.545H310.201C310.663 160.545 311.005 160.223 311.005 159.761C311.005 159.279 310.663 158.958 310.201 158.958H304.074C303.612 158.958 303.27 159.279 303.27 159.761C303.27 160.223 303.612 160.545 304.074 160.545Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2397_18030)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-71 280.197L-32.4354 270.322C5.55367 260.446 82.683 240.694 159.237 257.154C235.79 273.614 285.844 301.064 389.473 301.064C493.102 301.064 543.156 280.197 581.145 270.322L619.71 229.983L619.71 418.458L581.145 418.458C543.156 418.458 466.027 418.458 389.473 418.458C312.92 418.458 235.79 418.458 159.237 418.458C82.683 418.458 5.55369 418.458 -32.4354 418.458L-71 418.458L-71 280.197Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-8.99999 277.037L29.5646 267.162C67.5537 257.286 144.683 237.534 221.237 253.994C297.79 270.453 347.844 297.904 451.473 297.904C555.102 297.904 605.156 277.037 643.145 267.161L681.71 226.823L681.71 415.298L643.145 415.298C605.156 415.298 528.027 415.298 451.473 415.298C374.92 415.298 297.79 415.298 221.237 415.298C144.683 415.298 67.5537 415.298 29.5647 415.298L-8.99998 415.298L-8.99999 277.037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.57136e-06 299.159L38.5845 289.283C76.593 279.407 153.762 259.656 230.355 276.115C306.948 292.575 357.027 320.025 460.71 320.025C564.392 320.025 614.472 299.159 652.48 289.283L691.065 248.945L691.065 437.419L652.48 437.419C614.472 437.419 537.303 437.419 460.71 437.42C384.117 437.42 306.948 437.42 230.355 437.42C153.762 437.42 76.593 437.42 38.5845 437.42L1.34048e-05 437.42L3.57136e-06 299.159Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2397_18030",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.9999 303.5) rotate(-27.9177) scale(729.385 1294.43)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#035DCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "#489AED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DADEC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2397_18030"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 181H575V314C575 319.523 570.523 324 565 324H10C4.47716 324 0 319.523 0 314V181Z",
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoteHappening);
export default __webpack_public_path__ + "static/media/remote-happening.801401499e53029afdc548849f417de9.svg";
export { ForwardRef as ReactComponent };